<template>
  <div>
    <h2 class="text-20 font-bold mb-12">test2</h2>
    <p class="text-16 mb-16">Placeholder step 2</p>

    <div class="flex flex-row-reverse">
      <RouteStepperNextButton />
    </div>
  </div>
</template>

<script lang="ts">
import RouteStepperNextButton from '../../../../components/route_stepper/RouteStepperNextButton.vue';

export default {
  name: 'OnboardingParentCareUrgency',
  components: { RouteStepperNextButton },
};
</script>
